import { render, staticRenderFns } from "./SignatureExternal.vue?vue&type=template&id=47e2760c&"
import script from "./SignatureExternal.vue?vue&type=script&lang=js&"
export * from "./SignatureExternal.vue?vue&type=script&lang=js&"
import style0 from "./SignatureExternal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e2760c')) {
      api.createRecord('47e2760c', component.options)
    } else {
      api.reload('47e2760c', component.options)
    }
    module.hot.accept("./SignatureExternal.vue?vue&type=template&id=47e2760c&", function () {
      api.rerender('47e2760c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/SignatureExternal.vue"
export default component.exports